import { createSlice } from "@reduxjs/toolkit";

export interface AlertStore {
  title: string;
  description?: string;
  handleClick?: () => void;
  handleCancel?: () => void;
  hideCancel?: boolean;
  type: "error" | "warn" | "success";
  open: boolean;
}

export interface Action {
  payload: Omit<AlertStore, "open">;
  type: string;
}

const initialState: AlertStore = {
  title: "",
  description: "",
  type: "success",
  open: false,
};

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    showAlert: (state, action: Action) => {
      state = { ...action.payload, open: true };
      return state;
    },
    hideAlert: (state) => {
      state = { ...initialState };
      return state;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;

export default alertSlice;
